/**
 * Formats a number into a localized decimal string with a specified precision.
 *
 * Uses the Brazilian Portuguese (pt-BR) locale to format numbers with commas as decimal points
 * and periods as thousand separators.
 *
 * @param value - The number to format.
 * @param precision - Number of decimal places (default is 2).
 * @returns The formatted decimal string.
 *
 * @example
 * ```ts
 * toDecimal(1234.567); // '1.234,57'
 * toDecimal(1234.567, 1); // '1.234,6'
 * toDecimal(1234); // '1.234,00'
 * ```
 */
export function toDecimal(value: number, precision = 2) {
  const decimalFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  })

  return decimalFormatter.format(value)
}
